import type { TranslateFn } from '@/shared/utils/format-date.js';
import type { UserProfile } from '@/shared/utils/format-status.js';

export type AssignmentRow = {
    id: string;
    clientId: string;
    projectId: string;
    profile: UserProfile;
};

export type UserFormValidationInput = {
    name: string;
    email: string;
    isEdit: boolean;
    assignments: AssignmentRow[];
};

export function validateUserForm(input: UserFormValidationInput, translate: TranslateFn): Record<string, string> {
    const errs: Record<string, string> = {};
    if (!input.name.trim()) {
        errs.name = translate('users.nameRequired');
    }
    if (!input.isEdit) {
        if (!input.email.trim()) {
            errs.email = translate('users.emailRequired');
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.email)) {
            errs.email = translate('users.emailInvalid');
        }
    }
    const hasAdmProfile = input.assignments.some((a) => a.profile === 'ADM' && a.clientId);
    if (!hasAdmProfile) {
        const validAssignments = input.assignments.filter((a) => a.clientId && a.profile);
        if (validAssignments.length === 0) {
            errs.assignments = translate('users.atLeastOneAssignment');
        }
    }
    for (let i = 0; i < input.assignments.length; i++) {
        const a = input.assignments[i];
        if (a && a.clientId && !a.profile) {
            errs[`profile_${i}`] = translate('users.profileRequired');
        }
    }
    return errs;
}
